export default __webpack_public_path__ + "static/media/filter-results.c76eb145.svg";